export default __webpack_public_path__ + "static/media/dizzy-spirits-banner.72f341b9.png";